export default function LoadingIndicator (props = {
    className: null,
    color: null
}) {
    const { className, color, ...renderProps } = props

    return (
        <div
            className={`loading-indicator ${
                className || ''}`
                .trim()}
            aria-live="assertive"
            aria-label="Loading..."
            {...renderProps}
        >
            <svg
                xmlns="http://www.w3.org/2000/svg"
                width="50"
                height="50"
                viewBox="0 0 50 50"
                fill="none"
            >
                <circle
                    cx="25"
                    cy="25"
                    r="22.5"
                    strokeWidth="5"
                    stroke={color || '#9faeb9'}
                />
            </svg>
        </div>
    )
}
